import { render, staticRenderFns } from "./vRenIndividual.vue?vue&type=template&id=27c03bd0&"
import script from "./vRenIndividual.vue?vue&type=script&lang=js&"
export * from "./vRenIndividual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports